import 'date-fns';
import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/LicenseDetails";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomTextField from "../../CustomComponents/CustomTextField/CustomTextField";
import { useTranslation } from "react-i18next";
import CustomTypography from "../../CustomComponents/CustomTypography/CustomTypography";
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/Send';
import Divider from '@material-ui/core/Divider';
import { Checkbox, FormControlLabel, IconButton, InputAdornment } from "@material-ui/core";
import { CustomMoreVertIcon } from "../../CustomComponents/CustomIcon/CustomIcon";
import CustomIconButton from "../../CustomComponents/CustomIconButton/CustomIconButton";
import CustomMenu from "../../CustomComponents/CustomMenu/CustomMenu";
import CustomMenuItem from "../../CustomComponents/CustomMenuItem/CustomMenuItem";
import CustomCircularProgress from "../../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { GetCountryListAPI, GetUserLicenseAPI, UpsertLicenseAPI, SendEConsentAPI, DeleteLicenseAPI, SendUserEConsentAPI, GetUserLicenseLogsAPI } from "../../../services/LicenseCheckService";
import { LicenseCheckRequestType, LicenseCheckSettingEnum, LicenseCheckSettingValues, LicenseInsertionTypeEnum, LICENSE_OPERATION_STATUS_ENUM, UserLicenseView } from "../../../config/app-globals.enum";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import DateTime from "../../DateTime/DateTime";
import moment from "moment";
import CustomInputLabel from "../../CustomComponents/CustomInputLabel/CustomInputLabel";
import CustomSelect from "../../CustomComponents/CustomSelect/CustomSelect";
import CustomFormControl from "../../CustomComponents/CustomFormControl/CustomFormControl";
import CloseIcon from "@material-ui/icons/Close";
import DeleteLicenseDialog from "./DeleteLicense";
import ErrorAlert from "../../ErrorAlert/ErrorAlert";
import {
    getCountryData,
    setCountryData,
    getLicenseExpireSoonPeriod,
    getLicenseCheckStatus,
} from "../../../services/LocalStorageService";

import { dateDiffInDays } from '../../../config/app-global-method';
import ValidateLicenseConfirmDialog from './ValidateLicenseConfirmDialog';

const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function LicenseDetailsDialog(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.dialogOpen);
    const [addLicenseClicked, setAddLicenseClicked] = useState(!props.isLicenseAdded ? true : false);
    // const [rowSelectedIndex, setRowSelectedIndex] = useState(0);
    // const [lastSelectedLicenseId, setLastSelectedLicenseId] = useState("");
    const [isLicenseUpserted, setIsLicenseUpserted] = useState(false);
    const [countryList, setCountryList] = useState(getCountryData);
    const [isFormSubmit, setIsFormSubmit] = React.useState(false);
    const [licenseExpireSoonPeriod] = useState(getLicenseExpireSoonPeriod());
    const [isFocus, setIsFocus] = useState(true);
    // const [isLicenseCheck] = useState(getLicenseCheckStatus());
    // const [licenseCheckApiLoading, setLicenseCheckApiLoading] = useState(false);
    const [isApi, setIsApi] = useState(null);
    const [isUpsertLicenseApi, setIsUpsertLicenseApi] = useState(false);
    const [selectedLicenseSetting, setSelectedLicenseSetting] = useState(-1);
    const [selectedCountry, setSelectedCountry] = useState("-1");
    const [licenseData, setLicenseData] = useState({ id: "", licenseList: [] });
    const [isAutomaticLicenseExists, setIsAutomaticLicenseExists] = useState(true);
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
    const [licenseAlertMessage, setLicenseAlertMessage] = React.useState("");
    const [islicenseAlertOpen, setIsLicenseAlertOpen] = React.useState(false);
    const [licenseAlertStatusValue, setLicenseAlertStatusValue] = React.useState<any>("");
    const [licenseAlertType, setLicenseAlertType] = useState("error");
    const [isValidateConfirmDialogOpen, setIsValidateConfirmDialogOpen] = useState<boolean>(false);
    const [econsentOrValidationDialog, setEconsentOrValidationDialog] = useState("EC")
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [viewHistory, setViewHistory] = useState(false);
    const [isHistoryApiLoading, setIsHistoryApiLoading] = useState(false);
    const [historyData, setHistoryData] = useState<any[]>([]);

    const [selectedLicense, setSelectedLicense] = useState({
        id: "",
        userId: props.userId,
        licenseNo: "",
        issueDate: "",
        expiryDate: "",
        country: "",
        licenseType: "",
        points: -1,
        postCode: "",
        licenseCheckSetting: 0,
        isDefault: 0,
        recordStatus: 1,
        licenseOperationStatus: 0,
        licenseInsertionType: 0,
        licenseLogData: []
    });

    const [licenseFormValidation, setLicenseFormValidation] = useState({
        licenseNo: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
            pattern: ""
        },
        issueDate: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
            pattern: ""
        },
        expiryDate: {
            isRequired: false,
            isValid: true,
            validationMessage: "",
            pattern: ""
        },
        points: {
            isRequired: false,
            isValid: true,
            validationMessage: "",
            pattern: "^[0-9][0-9]*$"
        },
    });

    useEffect(() => {
        if (licenseData && licenseData.licenseList && licenseData.licenseList.length) {
            const existingAutomaticLicense = licenseData.licenseList.find((l) => l.licenseInsertionType === 1);
            if (existingAutomaticLicense) {
                setIsAutomaticLicenseExists(true);
            } else {
                setIsAutomaticLicenseExists(false);
            }
        } else {
            setIsAutomaticLicenseExists(false);
        }
    }, [licenseData])

    useEffect(() => {
        setOpen(props.dialogOpen);
    }, [props.dialogOpen]);

    useEffect(() => {
        try {
            if (props.userId !== null && props.userId !== undefined) {
                setIsApi(true);
                getLicenseData("READ");
            }
            getCountryDtls();
        } catch (error) {
            console.warn(error);
        }
    }, [props.userId]);

    useEffect(() => {
        if (viewHistory) {
            getHistoryData();
        } else {
            setHistoryData([]);
        }
    }, [viewHistory])

    const verifyUserInput = (userForm) => {
        setIsFocus(true);
        let formValid = true;
        const dateFormat = 'DD-MM-YYYY';
        if (userForm) {
            let _licenseFormValidation = { ...licenseFormValidation };
            for (const [key, value] of Object.entries(licenseFormValidation)) {
                const _value = { ...value };
                const currentValue = userForm[key];

                if (_value && _value.isRequired) {
                    if (!currentValue || !currentValue.length || currentValue === null) {
                        _value.isValid = false;
                        _value.validationMessage = t("THIS_FIELD_CAN_NOT_BE_EMPTY");
                        formValid = false;
                    } else {
                        _value.isValid = true;
                        _value.validationMessage = "";
                        if (key === "issueDate") {
                            const toDateFormat = moment(new Date(currentValue)).format(dateFormat);
                            if (!moment(toDateFormat, dateFormat, true).isValid()) {
                                _value.isValid = false;
                                _value.validationMessage = t("INVALID_DATE");
                                formValid = false;
                            }
                        }
                    }
                } else if (_value && currentValue !== undefined && currentValue !== null && currentValue.length > 0) {
                    if (key === "expiryDate") {
                        const toDateFormat = moment(new Date(currentValue)).format(dateFormat);
                        if (!moment(toDateFormat, dateFormat, true).isValid()) {
                            _value.isValid = false;
                            _value.validationMessage = t("INVALID_DATE");
                            formValid = false;
                        }
                    }
                    if (key === "points") {
                        if (currentValue.trim().match(_value.pattern) === null) {
                            _value.isValid = false;
                            _value.validationMessage = t("THIS_MUST_BE_A_NUMBER");
                            // setIsFormValid(false);
                            formValid = false;
                        }
                    }
                } else {
                    _value.isValid = true;
                    _value.validationMessage = "";
                }
                _licenseFormValidation[key] = { ..._value };
            }
            setLicenseFormValidation({ ..._licenseFormValidation, });
        }
        return formValid;
    };

    const handleClose = (action) => {
        setOpen(false);
        props.dialogClose(false, isLicenseUpserted);
    };

    const handleClickStartDatePicker = (event) => {
        if (event?.target?.value) {
            setStartDate(event.target.value);
            setSelectedLicense({ ...selectedLicense, issueDate: new Date(event.target.value).toUTCString(), });
            const obj = { ...selectedLicense, issueDate: new Date(event.target.value).toUTCString(), }
            updateLicenseData(obj);
        }
    };

    const handleClickEndDatePicker = (event) => {
        setEndDate(event.target.value);
        setSelectedLicense({ ...selectedLicense, expiryDate: new Date(event.target.value).toUTCString(), });
        const obj = { ...selectedLicense, expiryDate: new Date(event.target.value).toUTCString(), }
        updateLicenseData(obj);
    };

    const handleAddLicenseClick = () => {
        setViewHistory(false);
        setIsFormSubmit(false);
        setSelectedLicense({
            id: "",
            userId: props.userId,
            licenseNo: "",
            issueDate: "",
            expiryDate: "",
            country: "",
            licenseType: "",
            points: -1,
            postCode: "",
            licenseCheckSetting: 0,
            isDefault: 0,
            recordStatus: 1,
            licenseOperationStatus: 0,
            licenseInsertionType: 0,
            licenseLogData: []
        });
        setStartDate("");
        setEndDate("");
        // setRowSelectedIndex(-1);
        // setLastSelectedLicenseId("");
        setAddLicenseClicked(true);
        setSelectedLicenseSetting(-1);
        setSelectedCountry("-1");
    }

    const handleSendUserEConsentClick = async () => {
        setIsApi(true);
        setViewHistory(false);
        setIsFormSubmit(false);
        // setLicenseCheckApiLoading(true);
        const data = await SendUserEConsentAPI(props.userId);
        if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
            getLicenseData("BLANK_ADD");
        }
        licenseApiStatusCodeFunc(data.status, "ECONSENT_SENT");
        // setLicenseCheckApiLoading(false);
        setIsApi(false);
    }

    async function getLicenseData(operationType: string) {
        try {
            setIsApi(true);
            setIsFormSubmit(false);
            const data = await GetUserLicenseAPI(props.userId, UserLicenseView.ALL);
            setIsApi(false);
            let lastSelectedLicenseId: string = "";
            if (selectedLicense) {
                lastSelectedLicenseId = selectedLicense.id;
            }
            if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
                setLicenseData(data.content);
                handleAddLicenseClick();

                if (data.content.licenseList.length > 0) {
                    if (!["ADD", "DELETE", "BLANK_ADD"].includes(operationType) && lastSelectedLicenseId !== "") {
                        const existingSelectedLicense = data.content.licenseList.find(el => el.id === lastSelectedLicenseId);
                        if (existingSelectedLicense) {
                            showLicenseDetails(existingSelectedLicense);
                            // setSelectedLicense(existingSelectedLicense);
                        } else {
                            showLicenseDetails(data.content.licenseList[0]);
                            // setSelectedLicense(data.content.licenseList[0]);
                        }
                        // setRowSelectedIndex(rowSelectedIndex);
                        // props.getLicenseData();
                    } else {
                        showLicenseDetails(data.content.licenseList[0]);
                        // setSelectedLicense(data.content.licenseList[0]);
                        // setRowSelectedIndex(0);
                        // props.getLicenseData();
                    }
                } else {
                    setLicenseData({ id: "", licenseList: [] });
                    if (operationType === "DELETE") {
                        props.setIsLicenseAdded(false);
                    }
                }
            } else {
                setLicenseData({ id: "", licenseList: [] });
                setSelectedLicense({
                    id: "",
                    userId: props.userId,
                    licenseNo: "",
                    issueDate: "",
                    expiryDate: "",
                    country: "",
                    licenseType: "",
                    points: -1,
                    postCode: "",
                    licenseCheckSetting: 0,
                    isDefault: 0,
                    recordStatus: 1,
                    licenseOperationStatus: 0,
                    licenseInsertionType: 0,
                    licenseLogData: []
                });
            }
            licenseApiStatusCodeFunc(data.status, "GET_LICENSE");
            if (props.isAddLicense) {
                props.setIsAddLicense(false);
            }
            props.getLicenseData();
        } catch (error) {
            console.warn(error);
        }
    }

    async function getCountryDtls() {
        if (countryList === undefined || countryList === null) {
            const data = await GetCountryListAPI();
            if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
                setCountryData(data.content);
                setCountryList(data.content);
            }
        }
    }

    async function getHistoryData() {
        try {
            setHistoryData([]);
            if (selectedLicense) {
                setIsHistoryApiLoading(true);
                const data = await GetUserLicenseLogsAPI(selectedLicense.id);
                if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
                    const list: any[] = data.content;
                    if (list.length) {
                        setHistoryData(list);
                    }
                }
            }
        } catch (error) {
            console.warn(error);
        }
        setIsHistoryApiLoading(false);
    }

    const licenseApiStatusCodeFunc = (status, apiType) => {
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            if (apiType === "GET_LICENSE") {
                return;
            }
            let msg = "";
            if (apiType === "ADD_LICENSE") {
                msg = t("DRIVER_LICENSE_ADDED_SUCCESSFULLY");
            }
            if (apiType === "UPDATE_LICENSE") {
                msg = t("DRIVER_LICENSE_UPDATED_SUCCESSFULLY");
            }
            if (apiType === "DELETE_LICENSE") {
                msg = t("DRIVER_LICENSE_DELETED_SUCCESSFULLY");
            }
            if (apiType === "VALIDATE_LICENSE") {
                msg = t("DRIVER_LICENSE_VALIDATED_SUCCESSFULLY");
            }
            if (apiType === "ECONSENT_SENT") {
                msg = t("DRIVER_LICENSE_ECONSENT_SENT");
            }
            setLicenseAlertType("success");
            setLicenseAlertMessage(msg);
        } else {
            setLicenseAlertType("error");
            setLicenseAlertMessage(status.message ? status.message : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`);
        }
        setLicenseAlertStatusValue(status.code);
        setIsLicenseAlertOpen(true);
    };

    function showLicenseData(item: any) {
        try {
            setIsFormSubmit(false);
            setAddLicenseClicked(false);
            setViewHistory(false);
            showLicenseDetails(item);
        } catch (error) {
            console.warn(error)
        }
    }

    function showLicenseHisotry(item: any, index: number) {
        setSaveBtnDisabled(true);
        setIsFormSubmit(false);
        setViewHistory(true);
        setAddLicenseClicked(false);
        showLicenseDetails(item);
    }

    function showLicenseDetails(item) {
        try {
            setSaveBtnDisabled(true);
            setIsFormSubmit(false);
            if (item && item.licenseCheckSetting !== undefined && item.licenseCheckSetting !== null) {
                setSelectedLicenseSetting(item.licenseCheckSetting);
            } else {
                setSelectedLicenseSetting(-1);
            }
            if (item && item.country !== undefined && item.country !== null) {
                setSelectedCountry(item.country);
            }
            setStartDate(moment(item.issueDate).format("YYYY-MM-DD"));
            setEndDate(moment(item.expiryDate).format("YYYY-MM-DD"));
            setAddLicenseClicked(false);
            setSelectedLicense(item);
        } catch (error) {
            console.warn(error)
        }
    }

    const handleMarkDefaultChange = (event) => {
        setSelectedLicense({ ...selectedLicense, isDefault: (event.target.checked) ? 1 : 0, })
        const obj = { ...selectedLicense, isDefault: (event.target.checked) ? 1 : 0, }
        updateLicenseData(obj);
    };

    const handleLicenseSettingsChange = (event) => {
        setSelectedLicenseSetting(event.target.value);
        setSelectedLicense({ ...selectedLicense, licenseCheckSetting: event.target.value, });
        const updatedObj = { ...selectedLicense, licenseCheckSetting: event.target.value };
        updateLicenseData(updatedObj);
    };

    const handleCountryChange = (event) => {
        setSelectedCountry(event.target.value);
        setSelectedLicense({ ...selectedLicense, country: event.target.value, });
        const updatedObj = { ...selectedLicense, country: event.target.value };
        updateLicenseData(updatedObj);
    };

    async function upsertLicenseDetails(licenseObj?: any) {
        try {
            let licenseData = selectedLicense;
            if (licenseObj) {
                licenseData = licenseObj;
            }
            setIsApi(true);
            const data = await UpsertLicenseAPI(licenseData);
            setIsApi(false);
            if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201)) {
                setAddLicenseClicked(false);
                if (addLicenseClicked) {
                    props.setIsLicenseAdded(true);
                    getLicenseData("ADD");
                } else if (licenseObj) {
                    getLicenseData("DELETE");
                    props.setIsLicenseAdded(true);
                } else {
                    getLicenseData("READ");
                }
                setIsLicenseUpserted(true);
            }
            if (licenseObj) {
                licenseApiStatusCodeFunc(data.status, "DELETE_LICENSE");
            } else {
                if (addLicenseClicked) {
                    licenseApiStatusCodeFunc(data.status, "ADD_LICENSE");
                } else {
                    licenseApiStatusCodeFunc(data.status, "UPDATE_LICENSE");
                }

            }
            setIsUpsertLicenseApi(false);
        } catch (error) {
            console.warn(error);
        }
    }

    async function deleteLicenseData(isDelete) {
        if (isDelete) {
            setIsApi(true);
            const response = await DeleteLicenseAPI(selectedLicense);
            if (response && (response.status.code === 0 || response.status.code === 200 || response.status.code === 201)) {
                getLicenseData("DELETE");
                licenseApiStatusCodeFunc(response.status, "DELETE_LICENSE");
            }
            setIsApi(false);
        }
    }

    function handleSaveClick() {
        const validForm = verifyUserInput(selectedLicense);
        if (validForm) {
            setSaveBtnDisabled(true);
            setIsUpsertLicenseApi(true);
            upsertLicenseDetails();
        }
    }

    function handleRowClick(index, item) {
        setSaveBtnDisabled(true);
        setIsFormSubmit(false);
        setViewHistory(false);
        setAddLicenseClicked(false);
        // setRowSelectedIndex(index);
        showLicenseDetails(item);
    }

    function updateLicenseData(obj) {
        try {
            if (licenseData?.licenseList && licenseData.licenseList.length > 0) {
                // const oldLicenseDtls = licenseData.licenseList[rowSelectedIndex];
                const oldLicenseDtls = licenseData.licenseList.find(el => el.id === selectedLicense.id);
                if (oldLicenseDtls) {
                    setSaveBtnDisabled(compareLicenseObjects(oldLicenseDtls, obj));
                } else {
                    setSaveBtnDisabled(false);
                }
            } else {
                setSaveBtnDisabled(false);
            }
        } catch (error) {
            console.warn(error)
        }
    }

    function compareLicenseObjects(o1, o2) {
        try {
            for (var p in o1) {
                if (o1.hasOwnProperty(p)) {
                    if (o1[p] !== o2[p]) {
                        return false;
                    }
                }
            }
            for (var p in o2) {
                if (o2.hasOwnProperty(p)) {
                    if (o1[p] !== o2[p]) {
                        return false;
                    }
                }
            }
        } catch (error) {
            console.warn(error)
        }
        return true;
    }

    async function sendEconsentButtonClicked(id: string) {
        try {
            setIsFormSubmit(false);
            setEconsentOrValidationDialog("EC");
            setIsValidateConfirmDialogOpen(true);
        } catch (error) {
            console.warn(error);
        }
    }

    async function sendEconsentButtonClicked1(id: string) {
        try {
            setIsApi(true);
            // setLicenseCheckApiLoading(true);
            setIsFormSubmit(false);
            let data = null;
            if ([LICENSE_OPERATION_STATUS_ENUM.LICENSE_CREATED, LICENSE_OPERATION_STATUS_ENUM.CONSENT_SENT].includes(selectedLicense.licenseOperationStatus)) {
                data = await SendEConsentAPI(id);
            }
            if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
                getLicenseData("ADD");
                licenseApiStatusCodeFunc(data.status, "ECONSENT_SENT");
            } else {
                setLicenseAlertType("error");
                setLicenseAlertMessage(`${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`);
                setIsLicenseAlertOpen(true);
            }
            // setLicenseCheckApiLoading(false);
            setIsApi(false);
        } catch (error) {
            console.warn(error);
        }
    }

    async function validateLicenseButtonClicked() {
        try {
            // setLicenseCheckApiLoading(true);
            setIsFormSubmit(false);
            setEconsentOrValidationDialog("V");
            setIsValidateConfirmDialogOpen(true);
            // setLicenseCheckApiLoading(false);
        } catch (error) {
            console.warn(error);
        }
    }

    return (
        <CustomDialog
            onClose={() => handleClose(false)}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={'xl'}
            className={classes.dialogWrapper}
        >
            <CustomBox className={classes.titleWrapper}>
                <CustomTypography
                    component="h1"
                    variant="h5"
                    className={classes.licenseTitle}
                >
                    {t("LICENSES")}
                </CustomTypography>
                <CustomBox className={classes.buttonsContainer}>
                    <CustomBox className={classes.addLicenceButtonsWrapper}>
                        {isApi && <CustomCircularProgress
                            className={classes.circularProgressSmall}
                        />}
                        {!isAutomaticLicenseExists && !isApi &&
                            <CustomBox className={classes.addLicenceButton} onClick={() => handleSendUserEConsentClick()}>
                                <SendIcon style={{ color: 'rgb(255, 213, 0)', fontSize: 30 }} />
                                <CustomTypography
                                    component="h1"
                                    variant="h5"
                                    className={classes.addLicenceLabel}
                                >
                                    {t("SEND_ECONSENT_WITHOUT_ADDING_LICENCE")}
                                </CustomTypography>
                            </CustomBox>}
                    </CustomBox>

                    <CustomBox className={classes.addLicenceButtonsWrapper}>
                        {props.isLicenseAdded || licenseData?.licenseList?.length ?
                            <CustomBox className={classes.addLicenceButton} onClick={() => handleAddLicenseClick()}>
                                <AddIcon style={{ color: 'rgb(255, 213, 0)', fontSize: 30 }} />
                                <CustomTypography
                                    component="h1"
                                    variant="h5"
                                    className={classes.addLicenceLabel}
                                >
                                    {t("ADD_LICENSE")}
                                </CustomTypography>
                            </CustomBox> : null}
                        <IconButton aria-label="close" className={classes.closeButton} onClick={() => handleClose(false)} >
                            <CloseIcon />
                        </IconButton>
                    </CustomBox>
                </CustomBox>
            </CustomBox>
            <DialogContent className={classes.dialogContentWrapper}>
                {props.isLicenseAdded || licenseData?.licenseList?.length ?
                    <CustomBox className={classes.headingsWrapper}>
                        <CustomTypography
                            component="h1"
                            variant="h5"
                            style={{ width: '40%' }}
                            className={classes.headingText}
                        >
                            {t("LICENSE_NO")}
                        </CustomTypography>
                        <CustomTypography
                            component="h1"
                            variant="h5"
                            style={{ width: '35%' }}
                            className={classes.headingText}
                        >
                            {t("EXPIRY_DATE")}
                        </CustomTypography>
                        <CustomTypography
                            component="h1"
                            variant="h5"
                            style={{ width: '25%' }}
                            className={classes.headingText}
                        >
                            {t("POINTS")}
                        </CustomTypography>
                    </CustomBox> : null}
                <CustomBox className={classes.mainContent}>
                    {props.isLicenseAdded || licenseData?.licenseList?.length ?
                        <CustomBox className={classes.leftPanel}>
                            {addLicenseClicked ?
                                <>
                                    <div className={classes.licenseItemRowSelected}>
                                        <CustomBox className={classes.licenseItem}>
                                            <CustomBox className={selectedLicense.isDefault ? classes.licenseNoBlock : classes.licenseNoBlockWithoutTag}>
                                                {selectedLicense.isDefault ?
                                                    <CustomTypography className={classes.defaultTag}                                                    >
                                                        {"Default"}
                                                    </CustomTypography>
                                                    : null}
                                                <CustomTypography
                                                    component="h1"
                                                    variant="h5"
                                                    className={classes.licenceNumberText}
                                                >
                                                    {selectedLicense.licenseInsertionType === 0 ? selectedLicense.licenseNo : t('WAITING_FOR_ECONSENT')}
                                                </CustomTypography>
                                            </CustomBox>
                                            {selectedLicense.expiryDate !== null ?
                                                <CustomBox style={{ width: '35%', display: 'flex' }}>
                                                    <CustomBox style={{ display: 'flex' }} className={classes.licenceContent}>
                                                        {
                                                            selectedLicense.expiryDate !== "" &&
                                                            <>
                                                                <DateTime
                                                                    inputDate={selectedLicense.expiryDate}
                                                                    returnFormat="DD MMM"
                                                                />
                                                                ,<div style={{ marginLeft: '.25rem' }}></div>
                                                                <DateTime
                                                                    inputDate={selectedLicense.expiryDate}
                                                                    returnFormat="YYYY"
                                                                />
                                                            </>
                                                        }

                                                    </CustomBox>
                                                </CustomBox>
                                                : null}
                                            <CustomBox style={{ width: '20%', display: 'flex' }}>
                                                <CustomTypography
                                                    component="h1"
                                                    variant="h5"
                                                    className={classes.licenceContent}
                                                >
                                                    {selectedLicense.points !== undefined && selectedLicense.points !== null && selectedLicense.points >= 0 ? selectedLicense.points : null}
                                                </CustomTypography>
                                            </CustomBox>
                                        </CustomBox>
                                        <Divider />
                                    </div>
                                </>
                                : null}
                            {isApi && (
                                <CustomPaper
                                    className={classes.loadingContainer}
                                    elevation={0}
                                    style={{ padding: "2em" }}
                                >
                                    <CustomCircularProgress />
                                </CustomPaper>
                            )}
                            {!isApi && !addLicenseClicked && licenseData && !licenseData.licenseList.length && (
                                <CustomPaper className={classes.loadingContainer} elevation={0}>
                                    <CustomTypography
                                        paragraph={true}
                                        className={classes.title}
                                        style={{ padding: "2em" }}
                                    >
                                        {t("NO_RECORDS_FOUND")}.
                                    </CustomTypography>
                                </CustomPaper>
                            )}
                            {!isApi && licenseData && licenseData.licenseList.length ?
                                licenseData.licenseList.map((item, index) => {
                                    let isExpired = item.expiryDate && new Date(item.expiryDate) < new Date() ? true : false;
                                    let isExpiringSoon = false;
                                    if (item.expiryDate !== undefined && item.expiryDate !== null) {
                                        let expiryPeriod = dateDiffInDays(new Date(), new Date(item.expiryDate));
                                        isExpiringSoon = expiryPeriod <= licenseExpireSoonPeriod ? true : false;
                                    }
                                    // if (index === rowSelectedIndex) {
                                    //     item = selectedLicense;
                                    // }
                                    return <div key={item.id}>
                                        <div className={selectedLicense.id === item.id ? classes.licenseItemRowSelected : classes.licenseItemRow} onClick={() => handleRowClick(index, item)}>
                                            <CustomBox className={classes.licenseItem}>
                                                <CustomBox className={item.isDefault || isExpired || isExpiringSoon ? item.isDefault && (isExpired || isExpiringSoon) ? classes.licenseNoBlockWithMultipleTag : classes.licenseNoBlock : classes.licenseNoBlockWithoutTag}>
                                                    {item.isDefault ?
                                                        <CustomTypography
                                                            className={classes.defaultTag}
                                                        >
                                                            {t("DEFAULT")}
                                                        </CustomTypography> : null}
                                                    {
                                                        isExpired ?
                                                            <div>
                                                                <CustomTypography
                                                                    className={classes.expiredTag}
                                                                >
                                                                    {t("EXPIRED")}
                                                                </CustomTypography>
                                                            </div>
                                                            : isExpiringSoon ?
                                                                <CustomTypography
                                                                    className={classes.expiredTag}
                                                                >
                                                                    {t("EXPIRING_SOON")}
                                                                </CustomTypography>
                                                                : null
                                                    }
                                                    <CustomTypography component="h1" variant="h5" className={isExpired ? classes.expiredLicenceNumberText : classes.licenceNumberText} >
                                                        {item.licenseInsertionType === 0 ? item.licenseNo : t('WAITING_FOR_ECONSENT')}
                                                    </CustomTypography>
                                                </CustomBox>
                                                <CustomBox style={{ width: '35%', display: 'flex' }}>
                                                    <CustomBox style={{ display: 'flex' }} className={isExpired ? classes.expiredLicenseContent : classes.licenceContent}>
                                                        {item.expiryDate !== undefined && item.expiryDate !== null && item.expiryDate.length > 0 ? (
                                                            <>
                                                                <DateTime
                                                                    inputDate={item.expiryDate}
                                                                    returnFormat="DD MMM"
                                                                />
                                                                ,<div style={{ marginLeft: '.25rem' }}></div>
                                                                <DateTime
                                                                    inputDate={item.expiryDate}
                                                                    returnFormat="YYYY"
                                                                />
                                                            </>
                                                        ) : "-"}

                                                    </CustomBox>
                                                </CustomBox>
                                                <CustomBox style={{ width: '20%', display: 'flex' }}>
                                                    <CustomTypography
                                                        component="h1"
                                                        variant="h5"
                                                        className={isExpired ? classes.expiredLicenseContent : classes.licenceContent}
                                                    >
                                                        {item.points < 0 ? "-" : item.points}
                                                    </CustomTypography>
                                                </CustomBox>
                                                <CustomBox className={classes.actionOption}>
                                                    <IsolatedMenu item={item}
                                                        showLicenseHisotry={showLicenseHisotry}
                                                        showLicenseData={showLicenseData}
                                                        sendEconsentButtonClicked={sendEconsentButtonClicked}
                                                        validateLicenseButtonClicked={validateLicenseButtonClicked}
                                                        deleteLicenseData={deleteLicenseData}
                                                        // setRowSelectedIndex={setRowSelectedIndex}
                                                        showLicenseDetails={showLicenseDetails}
                                                        // rowSelectedIndex={index}
                                                        viewHistory={viewHistory}
                                                        setAddLicenseClicked={setAddLicenseClicked}
                                                    />
                                                </CustomBox>
                                            </CustomBox>
                                        </div>
                                        <Divider />
                                    </div>
                                }) : null}
                        </CustomBox> : null}
                    {addLicenseClicked || (licenseData && licenseData.licenseList.length) ?
                        (
                            <>
                                {!viewHistory ?
                                    <CustomBox className={classes.rightPanelParent}>
                                        <CustomTypography component="h1" variant="h5" className={classes.licenceLabel} >
                                            {!props.isLicenseAdded || addLicenseClicked ? t("ADD_LICENSE") : t("LICENSE_DETAILS")}
                                        </CustomTypography>
                                        <CustomBox className={classes.rightPanel}>
                                            <CustomTextField
                                                required
                                                disabled={false}
                                                className={classes.userInput}
                                                fullWidth
                                                type="text"
                                                label={`${t("LICENSE_NUMBER")}`}
                                                value={selectedLicense.licenseNo}
                                                onChange={(e) => {
                                                    const updatedObj = { ...selectedLicense, licenseNo: e.target.value };
                                                    setSelectedLicense({ ...selectedLicense, licenseNo: e.target.value, });
                                                    updateLicenseData(updatedObj);
                                                }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={input => {
                                                    if (input && !licenseFormValidation["licenseNo"].isValid && isFormSubmit && isFocus) {
                                                        input.focus();
                                                        setIsFocus(!isFocus);
                                                    }
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                    required: true
                                                    //     endAdornment: (
                                                    //         isLicenseCheck && selectedLicense.id.length ? licenseCheckApiLoading ?
                                                    //             <CustomCircularProgress
                                                    //                 className={classes.circularProgressSmall}
                                                    //             /> :
                                                    //             <InputAdornment position="end">
                                                    //                 <CustomButton className={classes.validateLabel} onClick={(e) => sendEconsentButtonClicked(selectedLicense.id)} disabled={!selectedLicense.licenseNo.length && selectedLicense.licenseInsertionType === LicenseInsertionTypeEnum.MANUAL && selectedLicense.licenseOperationStatus !== LICENSE_OPERATION_STATUS_ENUM.LICENSE_CREATED}>
                                                    //                     {t("SEND_ECONSENT")}
                                                    //                 </CustomButton>
                                                    //                 <CustomButton className={classes.validateLabel} onClick={(e) => validateLicenseButtonClicked()} disabled={!selectedLicense.licenseNo.length && selectedLicense.licenseInsertionType === LicenseInsertionTypeEnum.MANUAL && selectedLicense.licenseOperationStatus !== LICENSE_OPERATION_STATUS_ENUM.LICENSE_CREATED}>
                                                    //                     {t("VALIDATE")}
                                                    //                 </CustomButton>
                                                    //             </InputAdornment> : null
                                                    //     )
                                                }}
                                                error={
                                                    licenseFormValidation["licenseNo"].isValid || !isFormSubmit ? false : true
                                                }
                                                helperText={
                                                    isFormSubmit ? licenseFormValidation["licenseNo"].validationMessage : null
                                                }
                                            />
                                            < CustomTextField
                                                required
                                                id="startDate"
                                                disabled={false}
                                                className={classes.userInput}
                                                fullWidth
                                                type="date"
                                                label={`${t("START_DATE")}`}
                                                value={startDate}
                                                onChange={handleClickStartDatePicker}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                inputProps={{
                                                    max: endDate
                                                }}
                                                InputLabelProps={{ shrink: false }}
                                                inputRef={input => {
                                                    if (input && !licenseFormValidation["issueDate"].isValid && isFormSubmit && isFocus) {
                                                        input.focus();
                                                        setIsFocus(!isFocus);
                                                    }
                                                }}
                                                error={
                                                    licenseFormValidation["issueDate"].isValid || !isFormSubmit ? false : true
                                                }
                                                helperText={
                                                    isFormSubmit ? licenseFormValidation["issueDate"].validationMessage : null
                                                }
                                            />
                                            <CustomTextField
                                                disabled={false}
                                                className={classes.userInput}
                                                fullWidth
                                                type="date"
                                                label={`${t("END_DATE")}`}
                                                value={endDate}
                                                onChange={handleClickEndDatePicker}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                inputProps={{
                                                    min: startDate
                                                }}
                                                inputRef={input => {
                                                    if (input && !licenseFormValidation["expiryDate"].isValid && isFormSubmit && isFocus) {
                                                        input.focus();
                                                        setIsFocus(!isFocus);
                                                    }
                                                }}
                                                error={
                                                    licenseFormValidation["expiryDate"].isValid || !isFormSubmit ? false : true
                                                }
                                                helperText={
                                                    isFormSubmit ? licenseFormValidation["expiryDate"].validationMessage : null
                                                }
                                            />

                                            <CustomFormControl
                                                fullWidth
                                                className={classes.userInput}
                                            >
                                                <CustomInputLabel
                                                    shrink
                                                    id=""
                                                >
                                                    {t("COUNTRY_OF_ORIGIN")}{" "}
                                                </CustomInputLabel>
                                                <CustomSelect
                                                    labelId=""
                                                    disableUnderline
                                                    value={selectedCountry}
                                                    onChange={(e) => handleCountryChange(e)}
                                                >
                                                    <CustomMenuItem value="-1">
                                                        {t("SELECT")}
                                                    </CustomMenuItem>

                                                    {countryList && countryList.length > 0 ?
                                                        countryList.map((item, index) => (
                                                            <CustomMenuItem key={item.isoCode} value={item.isoCode} >
                                                                {t(item.name)}
                                                            </CustomMenuItem>
                                                        )) : null
                                                    }
                                                </CustomSelect>
                                                {/* <FormHelperText error>{licenseFormValidation["country"].isValid || !isFormSubmit ? null : licenseFormValidation["country"].validationMessage}</FormHelperText> */}
                                            </CustomFormControl>
                                            <CustomTextField
                                                disabled={false}
                                                className={classes.userInput}
                                                fullWidth
                                                type="text"
                                                label={`${t("TYPE_OF_LICENSE")}`}
                                                value={selectedLicense.licenseType}
                                                onChange={(e) => {
                                                    setSelectedLicense({ ...selectedLicense, licenseType: e.target.value, })
                                                    const updatedObj = { ...selectedLicense, licenseType: e.target.value };
                                                    updateLicenseData(updatedObj);
                                                }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />

                                            <CustomTextField
                                                disabled={false}
                                                className={classes.userInputPoints}
                                                fullWidth
                                                type="number"
                                                label={`${t("NUMBER_OF_POINTS")}`}
                                                value={selectedLicense.points < 0 ? "" : selectedLicense.points}
                                                onChange={(e) => {
                                                    setSelectedLicense({ ...selectedLicense, points: +e.target.value, })
                                                    const obj = { ...selectedLicense, points: +e.target.value }
                                                    updateLicenseData(obj);
                                                }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
                                                }}
                                                inputRef={input => {
                                                    if (input && !licenseFormValidation["points"].isValid && isFormSubmit && isFocus) {
                                                        input.focus();
                                                        setIsFocus(!isFocus);
                                                    }
                                                }}
                                                error={
                                                    licenseFormValidation["points"].isValid || !isFormSubmit ? false : true
                                                }
                                                helperText={
                                                    isFormSubmit ? licenseFormValidation["points"].validationMessage : null
                                                }
                                            />
                                            <CustomTextField
                                                disabled={false}
                                                className={classes.userInput}
                                                fullWidth
                                                type="text"
                                                label={`${t("POST_CODE")}`}
                                                value={selectedLicense.postCode}
                                                onChange={(e) => {
                                                    setSelectedLicense({ ...selectedLicense, postCode: e.target.value, });
                                                    const updatedObj = { ...selectedLicense, postCode: e.target.value };
                                                    updateLicenseData(updatedObj);
                                                }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                            <CustomFormControl
                                                fullWidth
                                                className={classes.userInput}
                                            >
                                                <CustomInputLabel
                                                    shrink
                                                    id=""
                                                >
                                                    {t("LICENSE_CHECK_SETTINGS")}{" "}
                                                </CustomInputLabel>
                                                <CustomSelect
                                                    labelId=""
                                                    disableUnderline
                                                    value={selectedLicenseSetting}
                                                    onChange={(e) => handleLicenseSettingsChange(e)}
                                                >
                                                    <CustomMenuItem value={LicenseCheckSettingEnum.NONE} >
                                                        {t("SELECT")}
                                                    </CustomMenuItem>
                                                    <CustomMenuItem value={LicenseCheckSettingEnum.WEEEK} >
                                                        {t(LicenseCheckSettingValues.WEEK)}
                                                    </CustomMenuItem>
                                                    <CustomMenuItem value={LicenseCheckSettingEnum.MONTH} >
                                                        {t(LicenseCheckSettingValues.MONTH)}
                                                    </CustomMenuItem>
                                                    <CustomMenuItem value={LicenseCheckSettingEnum.QUARTER} >
                                                        {t(LicenseCheckSettingValues.QUARTER)}
                                                    </CustomMenuItem>
                                                    <CustomMenuItem value={LicenseCheckSettingEnum.HALFYEAR} >
                                                        {t(LicenseCheckSettingValues.HALFYEAR)}
                                                    </CustomMenuItem>
                                                    <CustomMenuItem value={LicenseCheckSettingEnum.YEAR} >
                                                        {t(LicenseCheckSettingValues.YEAR)}
                                                    </CustomMenuItem>
                                                </CustomSelect>
                                            </CustomFormControl>

                                            <CustomBox className={classes.markDefault}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={selectedLicense.isDefault ? true : false}
                                                            onChange={(e) => handleMarkDefaultChange(e)}
                                                            name="checkedB"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={t("MARK_AS_DEFAULT")}
                                                />
                                            </CustomBox>
                                            <CustomButton
                                                // autoFocus  || selectedLicense?.licenseInsertionType === 1
                                                disabled={saveBtnDisabled}
                                                onClick={() => handleSaveClick()}
                                                variant="contained"
                                                color="primary"
                                                defaultrounded="true"
                                                className={classes.saveButton}
                                            >
                                                {t("SAVE")}
                                                {isUpsertLicenseApi && (
                                                    <>
                                                        {" "}
                                                        <CustomCircularProgress
                                                            thickness={5}
                                                            className={classes.circularProgressSmall}
                                                        />
                                                    </>
                                                )}
                                            </CustomButton>
                                        </CustomBox>
                                    </CustomBox>
                                    : null}
                                {viewHistory ?
                                    <>
                                        <CustomBox className={classes.rightPanelParent}>
                                            <CustomTypography component="h1" variant="h5" className={classes.licenceLabel} >
                                                {t("LICENSE_HISTORY")}
                                            </CustomTypography>
                                            <CustomBox className={classes.rightPanel}>
                                                <CustomBox className={classes.licenceDetailsWrapper}>
                                                    <CustomTypography
                                                        component="h1"
                                                        variant="h5"
                                                        className={classes.licenceHead}
                                                    >
                                                        {t("CHECK_DATE")}
                                                    </CustomTypography>
                                                    <CustomTypography
                                                        component="h1"
                                                        variant="h5"
                                                        className={classes.licenceHeadRequestedBy}
                                                    >
                                                        {t("TYPE")}
                                                    </CustomTypography>
                                                    <CustomTypography
                                                        component="h1"
                                                        variant="h5"
                                                        className={classes.licenceHeadRequestedBy}
                                                    >
                                                        {t("REQUESTED_BY")}
                                                    </CustomTypography>
                                                </CustomBox>
                                                {
                                                    isHistoryApiLoading ?
                                                        <CustomCircularProgress
                                                            thickness={5}
                                                            className={classes.circularProgressSmall}
                                                        />
                                                        :
                                                        historyData && historyData.length ?
                                                            historyData.map((item, index) => (
                                                                <CustomBox key={item.chekDate} className={classes.licenceDetailsWrapper}>
                                                                    <CustomBox className={classes.licenceExpiry}>
                                                                        <CustomBox style={{ display: 'flex' }} className={classes.licenceHistoryContent}>
                                                                            <DateTime
                                                                                inputDate={item.createdOn}
                                                                                returnFormat="DD MMM, YYYY"
                                                                            />
                                                                        </CustomBox>
                                                                    </CustomBox>
                                                                    <CustomBox className={classes.licenseCheckedBy}>
                                                                        <CustomTypography
                                                                            component="h1"
                                                                            variant="h5"
                                                                            className={classes.licenceHistoryContent}
                                                                        >
                                                                            {item.requestType === LicenseCheckRequestType.ECONSENT && t("ECONSENT")}
                                                                            {item.requestType === LicenseCheckRequestType.DRIVING_LICENSE_CHECK && t("VALIDATE")}
                                                                        </CustomTypography>
                                                                    </CustomBox>
                                                                    <CustomBox className={classes.licenseCheckedBy}>
                                                                        <CustomTypography
                                                                            component="h1"
                                                                            variant="h5"
                                                                            className={classes.licenceHistoryContent}
                                                                        >
                                                                            {item.usersname}
                                                                        </CustomTypography>
                                                                    </CustomBox>
                                                                </CustomBox>
                                                            ))
                                                            : <CustomPaper className={classes.loadingContainer} elevation={0}>
                                                                <CustomTypography
                                                                    paragraph={true}
                                                                    className={classes.title}
                                                                    style={{ padding: "2em" }}
                                                                >
                                                                    {t("NO_RECORDS_FOUND")}.
                                                                </CustomTypography>
                                                            </CustomPaper>
                                                }
                                            </CustomBox>
                                        </CustomBox>
                                    </>
                                    : null}
                            </>
                        ) : null
                    }
                </CustomBox>
            </DialogContent>
            <DialogActions className={classes.dialogActionWrapper}>
            </DialogActions>
            {isValidateConfirmDialogOpen &&
                <ValidateLicenseConfirmDialog
                    econsentOrValidationDialog={econsentOrValidationDialog}
                    setIsValidateConfirmDialogOpen={setIsValidateConfirmDialogOpen}
                    selectedLicense={selectedLicense}
                    licenseApiStatusCodeFunc={licenseApiStatusCodeFunc}
                    getLicenseData={getLicenseData} />
            }
            <ErrorAlert
                code={licenseAlertStatusValue}
                message={licenseAlertMessage}
                isOpen={islicenseAlertOpen}
                alertType={licenseAlertType}
                isClose={(isClose) => setIsLicenseAlertOpen(!isClose)}
            />
        </CustomDialog >
    );
}

const IsolatedMenu = ({ item, showLicenseHisotry, showLicenseData, deleteLicenseData, showLicenseDetails, sendEconsentButtonClicked, setAddLicenseClicked, viewHistory, validateLicenseButtonClicked }) => {
    const [userRowActionEl, setUserRowActionEl] = useState(null);
    const menuOpen = Boolean(userRowActionEl);
    // const classes = useStyles();
    const { t } = useTranslation();
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    // const [origin, setOrigin] = useState<any>({
    //     anchorOrigin: {
    //         vertical: 10,
    //         horizontal: "right",
    //     },
    //     transformOrigin: {
    //         vertical: 10,
    //         horizontal: "right",
    //     },
    // });

    function deleteDialog(e, item) {
        setUserRowActionEl(null);
        setDeleteDialogOpen(true);
    }

    function dialogClose(isDelete) {
        setDeleteDialogOpen(false);
        deleteLicenseData(isDelete);
    }

    function handleUserRowActionClick(e) {
        e.stopPropagation();
        setUserRowActionEl(e.currentTarget)
    }

    function handleMenuClick(e, item) {
        e.stopPropagation();
        setUserRowActionEl(null);
        // setRowSelectedIndex(rowSelectedIndex);
        showLicenseDetails(item);
        setAddLicenseClicked(false);
        if (e.target.id === "ViewDetails") {
            showLicenseData(item)
        } else if (e.target.id === "LicenseHistory") {
            showLicenseHisotry(item)
        } else if (e.target.id === "SEND_ECONSENT") {
            sendEconsentButtonClicked(item.id);
        } else if (e.target.id === "VALIDATE") {
            validateLicenseButtonClicked()
        }
    }

    return (
        <>
            <CustomIconButton
                aria-haspopup="true"
                onClick={(e) => handleUserRowActionClick(e)}
            >
                <CustomMoreVertIcon />
            </CustomIconButton>
            <CustomMenu
                anchorEl={userRowActionEl}
                open={menuOpen}
                onClose={() => setUserRowActionEl(null)}
                keepMounted
            >
                {viewHistory ?
                    <CustomMenuItem id="ViewDetails" onClick={(e) => { handleMenuClick(e, item) }}>
                        {t('VIEW_DETAILS')}
                    </CustomMenuItem> :
                    <CustomMenuItem id="LicenseHistory" onClick={(e) => { handleMenuClick(e, item) }}>
                        {t('LICENSE_CHECK_HISTORY')}
                    </CustomMenuItem>
                }
                {(item.licenseInsertionType === LicenseInsertionTypeEnum.AUTOMATIC || (item.licenseNo.length > 0 && item.licenseInsertionType === LicenseInsertionTypeEnum.MANUAL)) && item.licenseOperationStatus !== LICENSE_OPERATION_STATUS_ENUM.VALIDATED ?
                    <CustomMenuItem id="SEND_ECONSENT" onClick={(e) => { handleMenuClick(e, item) }}>
                        {t('SEND_ECONSENT')}
                    </CustomMenuItem> : null
                }
                {(item.licenseInsertionType === LicenseInsertionTypeEnum.AUTOMATIC || (item.licenseNo.length > 0 && item.licenseInsertionType === LicenseInsertionTypeEnum.MANUAL)) && item.licenseOperationStatus >= LICENSE_OPERATION_STATUS_ENUM.CONSENT_SENT ?
                    <CustomMenuItem id="VALIDATE" onClick={(e) => { handleMenuClick(e, item) }}>
                        {t('VALIDATE')}
                    </CustomMenuItem>
                    : null
                }
                <CustomMenuItem id="LicenseDelete" onClick={(e) => { deleteDialog(e, item) }}>
                    {t('DELETE')}
                </CustomMenuItem>
            </CustomMenu>
            {deleteDialogOpen ? (
                <>
                    <DeleteLicenseDialog
                        licenseNo={item.licenseNo}
                        dialogClose={dialogClose}
                    />
                </>
            ) : null
            }
        </>
    )
}
